import { render, staticRenderFns } from "./ShuttersType.vue?vue&type=template&id=e0277f3c"
import script from "./ShuttersType.vue?vue&type=script&lang=ts"
export * from "./ShuttersType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports